export default __webpack_public_path__ + "static/media/WinterNew.f6700478.jpg";